<div class="story-modal-wrapper">
  <mat-dialog-content>
    <div class="video-container">
      <button style="z-index: 10;" class="cmn-close" (click)="onNoClick()"></button>

      <div class="imageWrapper">
        <!-- YouTube Embed -->
        <ng-container *ngIf="isYouTubeVideo(data); else directVideo">
          <iframe
            width="100%"
            height="315"
            [src]="safeYouTubeUrl"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
            (load)="onVideoLoaded()">
          </iframe>
        </ng-container>

        <!-- Direct video -->
        <ng-template #directVideo>
          <video
            #videoPlayer
            [src]="data || '../../../assets/videos/placeholderVideo.mp4'"
            controls
            autoplay
            muted
            playsinline
            (loadeddata)="onVideoLoaded()"
            (error)="onVideoError()">
            Your browser does not support the video tag.
          </video>
        </ng-template>

        <!-- Loading / Error message -->
        <div class="video-overlay" *ngIf="loadError">
          <p>Error in loading the video or Invalid video url</p>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
